var UsernameError;
  var EmailError;
  var NumberError;
  var MessageError;
  
function validateUsername() {
  var name = document.querySelector("#ContactForm-name").value;
  var nameRegex = /^[A-Za-z]+$/;

  if (name === "") {
    jQuery(".name_message").text("Please enter your name");
    jQuery(".name_message").show();
    return false;
  } else if (!nameRegex.test(name)) {
    jQuery(".name_message").text("only alphabets are allowed");
    jQuery(".name_message").show();
    return false;
  } else {
    jQuery(".name_message").hide();
    return true;
  }
}


  
 function validateEmail() {
  var email = document.querySelector("#ContactForm-email").value;
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  if (email === "") {
    jQuery(".email_message").text("Please enter your email");
    jQuery(".email_message").show();
    return false;
  } else if (!emailRegex.test(email)) {
    jQuery(".email_message").text("Please enter a valid email");
    jQuery(".email_message").show();
    return false;
  } else {
    jQuery(".email_message").hide();
    return true;
  }
}


function validateNumber() {
  var phoneNumber = document.querySelector("#ContactForm-phone").value;
  var phoneRegex = /^\d{10}$/;

  if (phoneNumber === "") {
    jQuery(".number_message").text("Please enter your phone number");
    jQuery(".number_message").show();
    return false;
  } else if (!phoneRegex.test(phoneNumber)) {
    jQuery(".number_message").text("Please enter a valid phone number");
    jQuery(".number_message").show();
    return false;
  } else {
    jQuery(".number_message").hide();
    return true;
  }
}


  function validateMessage(){
 var d = document.querySelector("#ContactForm-body").value;
    if(d == ""){
        jQuery(".message").text("please enter you Message");
        MessageError = true;
         return false;
         jQuery(".message").show();
    }else{
      jQuery(".message").hide();
       MessageError = false;
       return true;
    } 
}

$('#ContactForm').on('submit', function () {
    validateUsername();
    validateEmail();
    validateNumber();
    validateMessage();
     if (UsernameError == true || EmailError == true || NumberError == true || MessageError == true ){
      return false;
    }else{
       return true;
    }
}); 






